import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useUIStore } from 'hooks/stores/useUIStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { useEffect } from 'react';

/** Checks that the current state of the various stores is valid for the user to
 * use the enter flow. e.g. if they already have an active subscription then
 * they are booted out of the flow
 */
export function useEnterFlowPreconditionCheck() {
  const userStore = useUserStore();
  const enterStore = useEnterStore();
  const uiStore = useUIStore();

  useEffect(() => {
    if (userStore.initialized && enterStore.initialised) {
      if (
        userStore.activeSubscriptions.length > 0 &&
        !enterStore.isUpgradeFlow
      ) {
        uiStore.navigateToDashboard();
        uiStore.displayToast({
          title:
            'You already have an active subscription to the Weekly Draw. Multiple subscriptions to the Weekly Draw are not allowed.',
          color: '#FF6600',
          timeout: 3500,
        });
      }
    }
  }, [
    // Importantly, we only want to run this once when the user store has initialised. Otherwise, we may end up running
    // the effect when the number of activeSubscriptions changes
    userStore.initialized,
    enterStore.initialised,
  ]);
}
